import React from "react";

function UserAvtarGroup() {
  return (
    <span className="anticon anticon-avtargroup">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 24 17"
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#545B66"
          strokeLinecap="round"
          strokeWidth="1.3"
          d="M1 14.038c0-2.25 3-2.25 4.5-3.75.75-.75-1.5-.75-1.5-4.5 0-2.5 1-3.75 3-3.75s3 1.25 3 3.75c0 3.75-2.25 3.75-1.5 4.5 1.5 1.5 4.5 1.5 4.5 3.75m-.208-2.273a13.73 13.73 0 001.21-.495c.55-.265 1.082-.566 1.498-.982.75-.75-1.5-.75-1.5-4.5 0-2.5 1-3.75 3-3.75s3 1.25 3 3.75c0 3.75-2.25 3.75-1.5 4.5 1.5 1.5 4.5 1.5 4.5 3.75m-11-2c.366-.124.63-.215.792-.273"
        ></path>
      </svg>
    </span>
  );
}

export default UserAvtarGroup;
